import { Content } from './content';
import { Bottom } from './bottom';
import { Top } from './top';
import classNames from 'classnames';

export const MainHeader = ({ children, className, ...r }) => {
  const classNameMainHeader = classNames("common-main-header", className);
  return (
    <div className={classNameMainHeader} {...r}>
      {children}
    </div>
  );
};

MainHeader.Top = Top;
MainHeader.Content = Content;
MainHeader.Bottom = Bottom;
